import * as yup from "yup";
import { useFormik } from 'formik';

import styles from './StoresSearch.module.scss';
import {CloseCircleFilled, LoadingOutlined} from "@ant-design/icons";


const InputButton = ({ search, inputValue, isSubmitting, resetCallback }) => {
    if (inputValue !== '' && search === inputValue) {
        return (
            <button className={styles.button} onClick={resetCallback}>
                <CloseCircleFilled/>
            </button>
        )
    }

    return (
        <button className={styles.button} type="submit">
            {isSubmitting ? (
                <LoadingOutlined spin/>
            ) : (
                <i className="fas fa-search"></i>
            )}
        </button>
    )
}

const StoresSearch = ({search, setSearch, counties}) => {
    const formProps = {
        initialValues: {
            search: '',
        },
        validationSchema: yup.object({
            search: yup
                .string()
                .trim()
                .trim()
                .nullable()
                .min(3, 'Musí obsahovať minimálne 3 znaky'),
        }),
        onSubmit: values => {
            setSearch(values.search);

            return true;
        },
    };

    const { values, handleSubmit, resetForm, isSubmitting, handleChange, touched, errors } =
        useFormik(formProps);

    const handleCountyClick = (county) => () => {
        resetForm();
        if (county === search) {
            setSearch('');
            return;
        }

        setSearch(county);
    }

    const handleClearSearchClick  = () => {
        setSearch('');
        resetForm();
    }

    return (
        <div className={styles.search}>
            <div className={styles.formWrapper}>
                <form onSubmit={handleSubmit}>
                    <input
                        name="search"
                        placeholder="Zadajte mesto alebo názov predajne..."
                        value={values?.search}
                        type="text"
                        onChange={handleChange}
                        // onChange={(e) => {
                        //     handleChange(e);
                        //     setSearch(e.target.value);
                        // }}
                    />
                    <InputButton search={search} inputValue={values?.search} isLoading={isSubmitting} resetCallback={handleClearSearchClick} />
                </form>
                {touched.search && errors.search ? (
                    <div className={styles.error}>{errors.search}</div>
                ) : null}
            </div>
            <div className={styles.counties}>
            {counties.map((county) => (
                    <a className={`button ${county === search ? styles.active : ''}`} key={`#county-${county}`} onClick={handleCountyClick(county)}>
                        {county} kraj
                        {county === search ? <CloseCircleFilled className={styles.countyCloseIcon}/> : null}
                    </a>
                ))}
            </div>
        </div>
    )
}

export default StoresSearch
